import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import {
  INVOKE_CHANGE_SERVER,
  INVOKE_CLEAR_STORAGE,
  invokeRNMessage,
  isNativeApp,
} from "../../../utils/nativeUtils";
import { SectionLink, SectionRow } from "./styles";

const RNativeSection = () => {
  const handleClickChangeServer = () => {
    invokeRNMessage(INVOKE_CHANGE_SERVER, window.location.href);
  };

  const handleClickClearStorage = () => {
    invokeRNMessage(INVOKE_CLEAR_STORAGE, window.location.href);
  };

  return isNativeApp() ? (
    <Fragment>
      <SectionRow>
        <SectionLink onClick={handleClickChangeServer}>
          <FormattedMessage id="webview.change_server" />
        </SectionLink>
      </SectionRow>
      <SectionRow>
        <SectionLink onClick={handleClickClearStorage}>
          <FormattedMessage id="webview.clear_storage" />
        </SectionLink>
      </SectionRow>
    </Fragment>
  ) : null;
};

export default RNativeSection;
